<template>
  <div>
    <h5 class="info-text">Selecciona el pedido</h5>
    <div class="md-layout">
      <div class="md-layout-item md-size-95 ml-auto mt-4 md-small-size-100">
        <md-table v-model="tableDataPlain">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label>
              <md-radio v-model="radio_product" :value="item.id"></md-radio>
            </md-table-cell>
            <md-table-cell md-label>
              <div class="img-product">
                <img :src="item.image">
              </div>
            </md-table-cell>
            <md-table-cell md-label="Product" class="td-name">
              {{ item.product }}
              <br>
              <small>{{ item.category }}</small>
            </md-table-cell>
            <md-table-cell md-label="Peso">{{ item.size }}</md-table-cell>
            <md-table-cell md-label="Price" class="td-number">
              {{ item.price }}
              <small>€</small>
            </md-table-cell>
            <md-table-cell md-label="Qty" class="td-number">{{ item.qty }}</md-table-cell>
            <md-table-cell md-label="Amount" class="td-number">
              {{ item.amount }}
              <small>€</small>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
  </div>
</template>
<script>
import { IconCheckbox } from "@/components";

export default {
  components: {
    IconCheckbox
  },
  data() {
    return {
      radio_product: null,
      model: {
        design: false,
        code: true,
        develop: false
      },
      tableDataPlain: [
        {
          id: "1",
          image: "/panel-reclamaciones/img/productos/3D-Ensalada-del-Chef.png",
          product: "Ensalada del Chef",
          category: "Mezcla",
          size: "125g",
          price: 0.99,
          qty: 20,
          amount: 18.8
        },
        {
          id: "2",
          image: "/panel-reclamaciones/img/productos/3D-Huerta-Corazon-de-Escarola-face.png",
          product: "Corazón de Escarola",
          category: "Ensaladas",
          size: "250g",
          price: 0.63,
          qty: 20,
          amount: 12.6
        },
        {
          id: "3",
          image: "/panel-reclamaciones/img/productos/3D-B-Templada-011.png",
          product: "Templada",
          category: "Completas",
          size: "250g",
          price: 2.99,
          qty: 10,
          amount: 29.9
        }
      ]
    };
  },
  methods: {
    validate() {
      this.$emit("on-validated", true, this.model);
      return Promise.resolve(true);
    }
  }
};
</script>
<style>
.img-product {
  width: 90px;
  height: 90px;
}
.img-product > img {
  width: 100%;
  height: 100%;
}
</style>
